var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('product-order-header-info',{ref:"orderHeaderInfo"}),_c('product-order-craft-info',{ref:"craftInfo"}),_c('product-order-machine-info',{ref:"workOrderInfo"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }